angular.module('impactx.MenuDirectives').controller('DeactivateThemeWorldSearchCtrl', [
    '$scope',
    '$context',
    'TranslationService',
    'ThemeWorldService',
    'ToastService',
    '$redirect',
    'dataGen',
    'searchFilter',
    '$workspace',
    DeactivateThemeWorldSearchCtrl]);

function DeactivateThemeWorldSearchCtrl($scope, $context, TranslationService, ThemeWorldService, ToastService, $redirect, dataGen, searchFilter, $workspace) {
    let self = this;
    self.showDeactivationButton = false;

    $scope.$watch(function() {
        return $context.hasActiveThemeWorldSearch.value
    }, function(newValue) {
        self.showDeactivationButton = newValue;
        self.deactivateThemeWorld = TranslationService.get('deactivateThemeWorld');
    });

    self.deactivateCurrentThemeWorld = function() {
        ThemeWorldService.deactivateActiveThemeWorldSearch(true).then(function(data) {
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                searchFilter.resetSearchFilter();
                ToastService.openStandardToast(data.trns.themeWorldDeactivated);
                $redirect.redirectTo(null, "search");
            });
        });
    };
}